module.exports = __webpack_public_path__ + "static/media/gant1.072ceebe.jpg";